const MyTheme = {
    navBar: { "color": "white", "backgroundColor": "black",
        "fontFamily": "'Courier New', 'Helvetica Neue', Helvetica, Arial, monospace"
    },
    navButton: { "color": "white", "backgroundColor": "black", "border" : "1px solid #FFF" }
}

export default MyTheme;